import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_hover, null, {
      default: _withCtx(({ isHovering, props }) => [
        _createVNode(_component_v_card, _mergeProps(props, {
          elevation: isHovering ? 4 : 0,
          class: 
                    _ctx.$vuetify.display.mobile
                        ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                        : 'default_card dashboard_card d-flex flex-column ma-0'
                ,
          style: _ctx.$vuetify.display.mobile ? 'height: 100%' : 'height: 250px'
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'title ma-2' : 'title ma-0 pa-2 pb-0')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.firstRowName) + " / " + _toDisplayString(_ctx.secondRowName), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "px-4 d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    (_ctx.checkTwoPeriods)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "5",
                              class: "d-flex flex-column justify-center align-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.loading)
                                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                      key: 0,
                                      size: 70,
                                      width: 7,
                                      color: "primary",
                                      indeterminate: "",
                                      style: {"margin":"24px"}
                                    }))
                                  : (_ctx.vuePourcentage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_ctx.differenceRatios > 0)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_avatar, {
                                                        color: "secondary",
                                                        size: "60"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, {
                                                            color: "white",
                                                            size: "large"
                                                          }, {
                                                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                              _createTextVNode(" $trending_up ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_row, {
                                                "no-gutters": "",
                                                "pt-2": "",
                                                "align-end": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { class: "d-flex font-weight-bold justify-center" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("+ " + _toDisplayString(_ctx.differenceRatios) + " %", 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ], 64))
                                          : (_ctx.differenceRatios < 0)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_avatar, {
                                                          color: "red",
                                                          size: "60"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                              color: "white",
                                                              size: "large"
                                                            }, {
                                                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                                _createTextVNode(" $trending_down ")
                                                              ])),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  "pt-2": "",
                                                  "align-end": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { class: "d-flex font-weight-bold justify-center" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.differenceRatios) + " %", 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_avatar, {
                                                          color: "grey",
                                                          size: "60"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                              color: "white",
                                                              size: "large"
                                                            }, {
                                                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                                _createTextVNode(" $fa-equals ")
                                                              ])),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  "pt-2": "",
                                                  "align-end": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { class: "d-flex font-weight-bold justify-center" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.differenceRatios) + " %", 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ], 64))
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        (_ctx.chartData)
                                          ? (_openBlock(), _createBlock(_component_bar_chart, {
                                              key: 0,
                                              data: _ctx.chartData,
                                              options: _ctx.options,
                                              width: _ctx.$vuetify.display.mobile ? 160 : 200,
                                              height: _ctx.$vuetify.display.mobile ? 112 : 140
                                            }, null, 8, ["data", "options", "width", "height"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "1" }),
                            (
                                    _ctx.chartData &&
                                    _ctx.chartData.datasets &&
                                    _ctx.chartData.datasets.length &&
                                    _ctx.chartData.datasets[0].data &&
                                    _ctx.chartData.datasets[0].data.length
                                )
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "6",
                                  class: "px-1 d-flex flex-column justify-center align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "d-flex align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex font-weight-bold"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$vuetify.display.mdAndDown ? "N" : "Ratio N"), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex font-weight-bold justify-end align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.ratioPeriodN) + " % ", 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$vuetify.display.mdAndDown ? "N-1" : "Ratio N-1"), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex justify-end align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.ratioPeriodNMoinsUn) + " % ", 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex justify-end align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_divider)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex"
                                        }, {
                                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                                            _createTextVNode(" Ecart ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.differenceRatios >= 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "+" + _toDisplayString(_ctx.differenceRatios) + " %", 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.differenceRatios) + " %", 1))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "d-flex align-center justify-center" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h1", null, _toDisplayString(_ctx.ratioPeriodN) + " %", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mt_auto d-flex align-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "pa-2 pt-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_icon, {
                              icon: "",
                              disabled: "",
                              size: "small"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.buttonVuePourcentage && _ctx.checkTwoPeriods && isHovering)
                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                  key: 0,
                                  icon: _ctx.vuePourcentage ? '$fa-chart-bar' : '$fa-percentage',
                                  "ma-2": "",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.vuePourcentage = !_ctx.vuePourcentage))
                                }, null, 8, ["icon"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                          default: _withCtx(() => [
                            isHovering
                              ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                  key: 0,
                                  "ma-2": "",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteTheCard()))
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["elevation", "class", "style"])
      ]),
      _: 1
    })
  ]))
}